import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/auth.context';
import { homePathForWallet, pagesForWallet } from '../../utils/constants';

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useAuth();
  const pages = pagesForWallet(auth?.username);
  const home = homePathForWallet(auth?.username);

  const handleClick = pageDetail => {
    navigate(pageDetail.path);
  };

  return (
    <aside className="game-sidebar" aria-label="Primary navigation">
      <Link to="/" className="game-brand" onClick={() => navigate(home)}>
        <span className="game-brand-mark">
          <img src="/images/cats/8338.png" alt="" />
        </span>
        <span className="game-brand-copy">
          <span className="game-brand-title">Catsaspell</span>
          <span className="game-brand-subtitle">operator console</span>
        </span>
      </Link>
      <ul className="game-nav">
        {pages.map(pageDetail => (
          <li className="game-nav-item" key={pageDetail.id}>
            <Link
              to={pageDetail.path}
              className={`game-nav-link ${
                location.pathname?.startsWith(pageDetail.path) ? 'active' : ''
              }`}
              aria-current={location.pathname?.startsWith(pageDetail.path) ? 'page' : undefined}
              onClick={() => handleClick(pageDetail)}
            >
              <i className={`fa-solid ${pageDetail.icon}`} aria-hidden="true"></i>
              <span>{pageDetail.name}</span>
            </Link>
          </li>
        ))}
      </ul>
      <div className="game-sidebar-footer">
        <div className="game-micro">status</div>
        <div className="small mt-1">Wallet-gated tools</div>
      </div>
    </aside>
  );
};

export default NavBar;
